import React from "react";
import { Container, Row, Col } from "reactstrap";
import courseImg1 from "../../assests/images/hospital-mgt.jpg";
import courseImg2 from "../../assests/images/kids-learning.png";
import courseImg3 from "../../assests/images/phonetics.jpg";
import "./courses.css";
import CourseCard from "./CourseCard";

const coursesData = [
  {
    id: "01",
    title: "Hospital Administration/ Management",
    lesson: 12,
    students: 12.5,
    rating: 5.9,
    imgUrl:
      "https://img.freepik.com/free-photo/female-physician-consulting-elderly-man-with-physical-impairment-having-medical-appointment-office-doctor-talking-patient-wheelchair-user-with-disability-giving-healthcare-support_482257-50420.jpg?t=st=1733483231~exp=1733486831~hmac=2047aa40ab655bf0f87766ab691f1947f63eb41cd653ba4b4ef0647b3c0edd69&w=740",
  },

  {
    id: "02",
    title: "Nephro Health",
    lesson: 12,
    students: 12.5,
    rating: 5.9,
    imgUrl:
      "https://img.freepik.com/free-vector/doctors-check-health-kidneys-urinary-system-clinic-medical-study-tiny-people-with-chronic-kidney-diseases-physiology-flat-vector-illustration-urology-nephrology-dialysis-concept_74855-21809.jpg?t=st=1733483581~exp=1733487181~hmac=e2d3b0b08335f1fdc99a5e574291ea37e1eef8adb8cefe77a0056242dd81fe72&w=740",
  },

  {
    id: "03",
    title: "Dialysis Nursing",
    lesson: 12,
    students: 12.5,
    rating: 5.9,
    imgUrl:
      "https://img.freepik.com/free-photo/african-american-medic-analyzing-x-ray-scan-diagnosis_482257-8992.jpg?t=st=1733484339~exp=1733487939~hmac=ed04b550135aa91983d0fa8d74abc27fc18f251265c7a57fe82be0a47bb3402c&w=740",
  },

  {
    id: "04",
    title: "Family Health",
    lesson: 12,
    students: 12.5,
    rating: 5.9,
    imgUrl:
      "https://img.freepik.com/free-photo/parents-spending-time-with-their-daughter_23-2149022797.jpg?t=st=1733483764~exp=1733487364~hmac=202f2f39bf83bb87a8f6051f996e4e65d920a5edb55855a616a7fecccbe6a235&w=740",
  },
];

const Courses = () => {
  return (
    <section id="courses">
      <Container>
        <Row>
          <Col lg="12" className="mb-5">
            <div className="course__top d-block d-md-flex d-lg-flex d-xl-flex justify-content-between align-items-center">
              <div className="course__top__left w-100 w-md-50 w-lg-50 w-xl-50">
                <h2>Our Popular Courses</h2>
                <p>
                  At Lofty Consulting, we offer a diverse range of courses
                  designed to elevate your professional journey. Our expert-led
                  programs combine practical knowledge with industry insights,
                  ensuring you stay ahead in your field. Here are some of our
                  most sought-after courses:
                </p>
              </div>

              <div className="w-50 text-start text-md-end text-lg-end text-xl-end">
                <button className="btn">See All</button>
              </div>
            </div>
          </Col>
          {coursesData.map((item) => (
            <Col lg="4" md="6" sm="6">
              <CourseCard key={item.id} item={item} />
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Courses;
